











































import Component from 'vue-class-component'
import RadioGroup from '@/components/RadioGroup.vue'
import Icon from '@/components/Icon.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import CollectionSharedFunctions from '@/views/app/management/collections/CollectionSharedFunctions'

@Component({
  props: {
    newTask: {
      required: true
    }
  },
  components: { TextArea, Icon, RadioGroup }
})
export default class CollectionActionCall extends CollectionSharedFunctions {
  callAction: string = 'Left a message'
  radioOptions: any = [{
    key: '1',
    value: 'Left a message',
    content: 'Left a message'
  }, {
    key: '2',
    value: 'Spoke with resident',
    content: 'Spoke with resident'
  }, {
    key: '3',
    value: 'Call not answered',
    content: 'Call not answered'
  }]

  validateTaskNote () {
    return !!this.$props.newTask.note
  }

  setCallAction (value: string) {
    this.callAction = value
  }

  setNewTaskField (propName: string, item: any) {
    this.$set(this.$props.newTask, propName, item)
    this.$forceUpdate()
  }

  async takeActionCalled () {
    if (!this.validateTaskNote()) {
      return
    }
    this.$emit('submit', {
      functionName: 'takeActionResidentCalled',
      successMessage: 'Called Action Saved',
      payloadData: {
        note: this.$props.newTask.note as string,
        callAction: this.callAction
      }
    })
  }
}
